import store from '@/store';
import { IWizardDefinition, IWizardStepDefinition } from '@/components/DSE/WizardRenderer/interfaces';
import ProductionPlanningCapacity from '@/pages/planning/capacity/ProductionPlanningCapacity.vue';
import ProductionPlanningSelection from '@/pages/planning/selection/ProductionPlanningSelection.vue';
import ProductionPlanningSeries from '@/pages/planning/series/ProductionPlanningSeries.vue';

const stepCapacity: IWizardStepDefinition = {
  title: 'planning.capacityStep',
  showWizardButtons: false,
  stepLabelWidth: '100px',
  formDefinition: {
    selectionStep: {
      type: ProductionPlanningCapacity,
      props: {
        caption: 'common.emptyString'
      }
    }
  },
  hiddenActionDefinition: {
    startSelectionStep: {
      action: (wizardForm, next, done, params) => {
        wizardForm.domainID = params['domainID'];
        wizardForm.planningOption = params['planningOption'];
        wizardForm.excludedStoreIDs = params['excludedStoreIDs'];
        wizardForm.excludedStoreAttributeIDs = params['excludedStoreAttributeIDs'];
        wizardForm.installationServiceOption = params['installationServiceOption'];
        wizardForm.samplesOnlyYN = params['samplesOnlyYN'];
        next(1);
      }
    }
  }
};

const stepSelection: IWizardStepDefinition = {
  title: 'planning.selectionStep',
  showWizardButtons: false,
  stepLabelWidth: '0px',
  formDefinition: {
    selectionStep: {
      type: ProductionPlanningSelection,
      props: {
        caption: 'common.emptyString'
      },
      dynamicProps: wizardForm => ({
        domainID: parseInt(wizardForm.domainID),
        selectedPlanningOption: parseInt(wizardForm.planningOption),
        excludedStoreIDs: wizardForm.excludedStoreIDs,
        excludedStoreAttributeIDs: wizardForm.excludedStoreAttributeIDs,
        installationServiceOption: wizardForm.installationServiceOption,
        samplesOnlyYN: wizardForm.samplesOnlyYN
      })
    }
  },
  hiddenActionDefinition: {
    startSeriesStep: {
      action: (wizardForm, next, done, params) => {
        next(1);
      }
    }
  }
};
const stepSeries: IWizardStepDefinition = {
  title: 'planning.seriesStep',
  showWizardButtons: false,
  stepLabelWidth: '0px',
  formDefinition: {
    seriesStep: {
      type: ProductionPlanningSeries,
      props: {
        caption: 'common.emptyString'
      },
      dynamicProps: wizardForm => ({
        domainID: parseInt(wizardForm.domainID),
        selectedPlanningOption: parseInt(wizardForm.planningOption)
      })
    }
  },
  hiddenActionDefinition: {
    finishSelectionStep: {
      action: (wizardForm, next, done, params) => {
        next(-2);
      }
    }
  }
};
export function getDefinition(vue) {
  const selectionWizardDefinition: IWizardDefinition = {
    // All of these 'before' hook should support async actions
    // If false is returned or a Promise is returned and then is rejected, action will be aborted
    beforeExit: async wizardForm => {
      if (!(await store.dispatch('wizard/validate'))) {
        store.dispatch('notify/error', { message: 'Validation failed' });
        throw new Error('Validation failed');
      }
    },
    beforeStep: (wizardForm, stepIndex, stepName) => {},
    showOverview: true, // Show overview of all steps
    steps: [stepCapacity, stepSelection, stepSeries]
  };

  return selectionWizardDefinition;
}
